export function isEmailValid(email: string = ''): boolean {
  const at = email.indexOf('@');
  const dot = email.lastIndexOf('.');
  return (
    email.length > 0 &&
    at > 0 &&
    at === email.lastIndexOf('@') &&
    dot > at + 1 &&
    dot < email.length &&
    email[at + 1] !== '.' &&
    email.indexOf(' ') === -1 &&
    email.indexOf('..') === -1 &&
    email.indexOf('.@') === -1 &&
    email.indexOf('+@') === -1 &&
    email[email.length - 1] !== '.' &&
    email[0] !== '.' &&
    /^[\x00-\x7F]*$/.test(email) // eslint-disable-line no-control-regex
  );
}

export function validateEmail(email: string): string | null {
  if (!email || email.trim() === '') {
    return 'This field is required';
  }
  if (!isEmailValid(email)) {
    return 'Please enter a valid email address';
  }
  return null;
}
